import * as yup from 'yup';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

export const useMailAccountFormValidation = () => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    address: yup.string().required(formatMessage({ id: AppMessages['common.validation.required'] })),
    username: yup
      .string()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .max(20, formatMessage({ id: AppMessages['definitions.mailAccount.username.validation.maxLength'] }))
      .nullable()
      .optional(),
    authentication: yup.string().required(formatMessage({ id: AppMessages['common.validation.required'] })),
    port: yup
      .string()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .min(2, formatMessage({ id: AppMessages['definitions.mailAccount.port.validation.minLength'] }))
      .max(3, formatMessage({ id: AppMessages['definitions.mailAccount.port.validation.maxLength'] }))
      .nullable()
      .optional(),
    password: yup
      .string()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .max(30, formatMessage({ id: AppMessages['definitions.mailAccount.password.validation.maxLength'] }))
      .nullable()
      .optional(),
  });

  return { schema };
};
